import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../assits/logo.svg";
import "./navbar.scss";

function NavBar() {
  return (
    <div className="myNavbar">
      <Link to="/">
        <Logo className="logo" />
      </Link>
      <div className="links">
        <Link to="/rules" className="link">
          RULES
        </Link>
        <Link to="/login" className="link">
          LOG IN
        </Link>
      </div>
    </div>
  );
}

export default NavBar;
